












































import { Component, Vue } from "vue-property-decorator";
import Oportunity from "@/components/Oportunity.vue";
@Component({
  components: {
    Oportunity
  }
})
export default class Oportunities extends Vue {
    get oportunities(): [] {
      return this.$store.state.oportunities;
    }
    mounted() {
        this.$store.dispatch('bindOportunities');
    }
}
